/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * High-level category for invoice classification in the new billing system.
 */
export enum InvoiceCategory {
    /**
     * Unknown or unclassified category.
     */
	Unknown = 'Unknown',
    /**
     * Revenue recognition invoices representing services rendered.
     */
	Revenue = 'Revenue',
    /**
     * Funding invoices that collect money in advance (annual customers).
     */
	Prepayment = 'Prepayment',
    /**
     * Credit notes that increase CreditBalance.
     */
	Credit = 'Credit',
    /**
     * Cash refunds back to original payment method.
     */
	Refund = 'Refund',
    /**
     * Internal wallet bookkeeping invoices that are not shown to the customer (e.g., direct cash-balance adjustments).
     */
	Internal = 'Internal',
}
